<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{ $t('modification.register_license.title') }}
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{ $t('modification.title') }} > </span>
            <span class="middle_loc">{{ $t('modification.register_license.title') }} > </span>
            <span class="back_loc">{{ $t('common.common.new') }}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap type2">
          <v-layout class="step_wrapper type2">
            <v-flex class="step_box step01">
              <h2>{{ $t('modification.register_license.fields.step_01') }}</h2>
              <p>{{ $t('modification.register_license.fields.search_application') }}</p>
            </v-flex>
            <v-flex class="step_box step02">
              <h2>{{ $t('modification.register_license.fields.step_02') }}</h2>
              <p>{{ $t('modification.register_license.fields.enter_details') }}</p>
            </v-flex>
            <v-flex class="step_box step03 active">
              <h2>{{ $t('modification.register_license.fields.step_03') }}</h2>
              <p>{{ $t('modification.register_license.fields.review_submit') }}</p>
            </v-flex>
          </v-layout>

          <v-layout column class="ma-0 pos-r center__wrapper mt-30">
            <v-flex class="inner_basic_wrap type2 inner_contents">
              <v-tabs
                v-model="activeTab"
                class="my_app_tabs_data type2"
                hide-slider
                grow
              >
                <v-tab :href="'#tab-1'" class="mw-200">{{ $t('modification.register_license.fields.requests')  }}</v-tab>
                <v-tab :href="'#tab-2'" class="mw-200">{{ $t('modification.register_license.fields.attached_documents')  }}</v-tab>

                <v-tab-item :value="`tab-1`">
                  <ApplicationInformation2 :receipt_no="receipt_no" />

                  <h2 class="m_title solo mt-15">{{ $t('modification.register_license.fields.request_license_type') }}</h2>
                  <div class="pl-15 pr-15">
                    <v-radio-group
                      row
                      v-model="licenseTypeCode"
                      class="view__radio"
                    >
                      <template v-for="(code, i) in $vuetify.rtl ? typeCodeListAr : typeCodeListEn">
                        <v-radio
                          :key="code.value"
                          :label="code.text"
                          :value="code.value"
                          color="#a01c2a"
                          class="ft-size12"
                          disabled
                          readonly
                        >
                        </v-radio>
                        <v-spacer class="hidden_lr10" :key="i" v-if="i==0"></v-spacer>
                      </template>
                    </v-radio-group>
                  </div>

                  <v-flex class="item_box pa-0" style="border-bottom: none" v-if="licenseTypeCode === '5631'">
                    <h2 class="m_title solo mt-35">{{ $t('modification.register_license.fields.patent_information') }}</h2>
                    <v-col cols="12" class="pa-0">
                      <v-data-table
                        :headers="$getHeaderType1(applicationPatentHeaderTxt, applicationPatentHeaders)"
                        :items="applicationPatentList"
                        hide-default-footer
                        disable-pagination
                        disable-sort
                        class="new__type__table__view"
                      >
                        <template v-slot:item.months="{ item }">
                          {{ $t('common.message.months_days', {months: item.months, days: item.days})}}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-flex>

                  <v-flex class="item_box pa-0" style="border-bottom: none" v-if="licenseTypeCode === '5631'">
                    <h2 class="m_title solo mt-35">{{ $t('modification.register_license.fields.license_information') }}</h2>
                    <v-col>
                      <v-row class="pl-15 pr-15">
                        <v-col cols="3" class="pa-0">
                          <label class="nec_title">{{ $t('modification.register_license.fields.license_date') }}</label>
                          <v-row>
                            <v-col cols="12" class="pt-0 pr-30">
                              <v-text-field
                                outlined
                                solo
                                dense
                                flat
                                append-icon="mdi-calendar"
                                class="ft-size12 br_none"
                                v-model="contractDate"
                                readonly
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="3" class="pa-0">
                          <label class="nec_title">{{ $t('modification.register_license.fields.from_date') }}</label>
                          <v-row>
                            <v-col cols="12" class="pt-0 pr-30">
                              <v-text-field
                                outlined
                                solo
                                dense
                                flat
                                append-icon="mdi-calendar"
                                class="ft-size12 br_none"
                                v-model="startDate"
                                readonly
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="3" class="pa-0">
                          <label class="nec_title">{{ $t('modification.register_license.fields.expiration_date') }}</label>
                          <v-row>
                            <v-col cols="12" class="pt-0 pr-30">
                              <v-text-field
                                outlined
                                solo
                                dense
                                flat
                                append-icon="mdi-calendar"
                                class="ft-size12 br_none"
                                v-model="endDate"
                                readonly
                              ></v-text-field>
                            </v-col>
                          </v-row>
                        </v-col>
                        <v-col cols="3" class="pa-0">
                          <label class="nec_title">{{ $t('modification.register_license.fields.period') }}</label>
                          <v-row>
                            <v-col cols="12">
                              <div v-if="(months !== null && days !== null)" class="ft-size12">
                              {{ $t('common.message.months_days', {months: months, days: days})}}
                              </div>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-flex>

                  <v-flex class="my_app_tabs_data mt-25" v-if="licenseTypeCode === '5631'">
                    <h2 class="m_title solo">{{ $t('modification.register_license.fields.licensee') }}</h2>
                    <v-row>
                      <v-col cols="12" class="pt-0">
                        <v-data-table
                          :headers="$getHeaderType1(headerTxt, headers)"
                          :items="licenseeList"
                          hide-default-footer
                          disable-pagination
                          :mobile-breakpoint="MobileBreakPoint"
                          class="new__type__table__view"
                        >
                          <template v-slot:item="{ item, index }">
                            <tr>
                              <td>
                                {{ index + 1 }}
                              </td>
                              <td>
                                <p>{{ item.name_ar }}</p>
                                <p>{{ item.name_en }}</p>
                              </td>
                              <td>
                                <p>{{ item.address_ar }}</p>
                                <p>{{ item.address_en }}</p>
                              </td>
                              <td>
                                {{ item.nationality_code }}
                              </td>
                              <td>
                                {{ item.residence_country_code }}
                              </td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-flex>

                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore()"
                        >{{ $t('common.button.before') }}</v-btn>
                        <v-btn
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="!contentConfirm"
                          @click.stop="fnConfirmContent()"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="contentConfirm"
                          @click.stop="fnCancelContent()"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          :disabled="!confirmYn"
                          @click="fnSubmit()"
                        ><v-icon>mdi-send</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.submit') }}</v-btn>
                      </div>

                    </div>
                  </div>
                </v-tab-item>

                <v-tab-item :value="`tab-2`">
                  <DocumentViewer
                    :items="documentFileList"
                  />

                  <!-- 버튼 고정형 레이아웃 -->
                  <div class="btn__fixed__wrapper">
                    <div class="btn__fixed__wrap">
                      <div class="btn_fixed__inner">
                        <v-btn
                          color="#acb0b3"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          @click="fnGoBefore()"
                        >{{ $t('common.button.before') }}</v-btn>


                        <v-btn
                          color="#007aff"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="!docConfirm"
                          @click.stop="fnConfirmDoc()"
                        ><v-icon small>mdi-check</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm') }}</v-btn>

                        <v-btn
                          color="#404040"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          v-if="docConfirm"
                          @click.stop="fnCancelDoc()"
                        ><v-icon small>mdi-close</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.confirm_cancel') }}</v-btn>

                        <v-btn
                          color="#a01c2a"
                          dark
                          min-width="150"
                          min-height="50"
                          class="btn-normal br_none"
                          :disabled="!confirmYn"
                          @click="fnSubmit()"
                        ><v-icon>mdi-send</v-icon><v-spacer class="hidden_lr5"></v-spacer>{{ $t('common.button.submit') }}</v-btn>
                      </div>
                    </div>
                  </div>

                </v-tab-item>
              </v-tabs>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>

    </v-layout>
  </v-container>
</template>

<script>
import requestApi from '@/utils/requestApi'
import utils from '@/utils/utils'
import eventBus from '@/utils/eventBus'
import DocumentViewer from '@/components/layout/DocumentViewer'
import ApplicationInformation2 from '@/components/layout/ApplicationInformation2'

export default {
  components :{
    DocumentViewer,
    ApplicationInformation2
  },
  data () {
    return {
      activeTab : 'tab-1',
      paymentTabShow : false,
      MobileBreakPoint : 0,
      receipt_no : this.$route.params.receipt_no,
      documentFileList: [],
      notes : '',
      licenseTypeCode : '',
      registerLicenseSeq: null,
      contractDate: '',
      startDate: '',
      endDate: '',
      typeCodeListAr: [],
      typeCodeListEn: [],

      docConfirm : false,
      contentConfirm : false,

      headerTxt : {
        prefix : 'modification.register_license.fields.',
        txt : [ '#', 'name','address','nationality_country_code','residence_country_code' ]
      },

      headers: [
        { text: '#', align: 'center', sortable: false, value: 'no', width:'50'},
        { text: this.$t('modification.register_license.fields.name'), align: 'center', sortable: false, value: '' },
        { text: this.$t('modification.register_license.fields.address'), align: 'center', sortable: false, value: '' },
        { text: this.$t('modification.register_license.fields.nationality_country_code'), align: 'center', sortable: false, value: '' },
        { text: this.$t('modification.register_license.fields.residence_country_code'),  align: 'center', width: '98px', sortable: false, value: '' }
      ],
      licenseeList : [],
      applicationPatentList: [],

      applicationPatentHeaderTxt : {
        prefix : 'modification.register_license.fields.',
        txt : [ 'application_no', 'patent_no', 'grant_date', 'expiration_date', 'remaining_period' ]
      },

      applicationPatentHeaders: [
        { text: 'Application No', align: 'center', value: 'application_no', width: 150 },
        { text: 'Patent No', align: 'center', value: 'grant_no', width: 200 },
        { text: 'Grant Date', align: 'center', value: 'grant_date', width: 120 },
        { text: 'Expiration Date', align: 'center', value: 'expiration_date', width: 120 },
        { text: 'The Remaining period of the protection', align: 'center', value: 'months' },
      ],

      months: null,
      days: null
    }
  },
  computed : {
    confirmYn (){
      return this.docConfirm && this.contentConfirm
    }
  },
  mounted(){
    window.scrollTo(0, 0)

    this.fnGetReceipt()
    this.fnGetTypecode()
    this.fnGetRegisterLicense()
    this.fnGetDocumentFileList()
    this.fnGetPayMentYn()
  },
  methods: {
    fnGetPayMentYn(){
      requestApi({
        url: '/receivings/' + this.receipt_no + '/fee',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {

            if(res.data.payment_fee_type_code == '4502'){
              this.paymentTabShow = true
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPayMentYn()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetTypecode(){
      let options = {
        upper_code: '5630'
      }
      utils.fnGetCodeList(options).then(list => {
        this.typeCodeListAr = list.ar
        this.typeCodeListEn = list.en
      })
    },

    fnGetRegisterLicense(){
      requestApi({
        url: '/receivings/register/license/'+this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.registerLicenseSeq = res.data.seq
            this.licenseTypeCode = res.data.license_type_code
            this.contractDate = res.data.contract_date
            this.startDate = res.data.start_date
            this.endDate = res.data.end_date

            if (this.startDate && this.endDate) {
              this.fnGetPeriod()
            }

            // patent 목록
            if (this.licenseTypeCode === '5631') {
              this.fnGetApplicationPatentList()
              this.fnGetLicensees()
            }
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetRegisterLicense()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetApplicationPatentList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/application/patents',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.applicationPatentList = res.data.list
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetApplicationPatentList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },


    fnGetDocumentFileList() {
      requestApi({
        url: '/receivings/'+ this.receipt_no +'/documents/files',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            this.documentFileList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetDocumentFileList()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
    fnConfirmDoc(){
      let params = {
        ind_attached_confirm : 'Y'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/attached/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.docConfirm = true

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmDoc()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnCancelDoc(){
      let params = {
        ind_attached_confirm : 'N'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/attached/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.cancel_confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.docConfirm = false

          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnCancelDoc()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnConfirmContent(){
      let params = {
        request_content_confirm : 'Y'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/request/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.contentConfirm = true
            this.activeTab = 'tab-2'
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnConfirmContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnCancelContent(){
      let params = {
        request_content_confirm : 'N'
      }
      requestApi({
        url: '/receivings/' + this.receipt_no + '/request/confirm',
        method: 'PUT',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.cancel_confirm.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.contentConfirm = false
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnCancelContent()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetLicensees(){
      requestApi({
        url: '/receivings/register/license/' + this.receipt_no + '/licensees',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            for (let i = 0; i < res.data.list.length; i++) {
              res.data.list[i].no = res.data.list.length - i
            }
            this.licenseeList = res.data.list
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetLicensees()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGetPeriod() {
      let params = {
        start_date: this.startDate,
        end_date: this.endDate
      }

      requestApi({
        url: '/receivings/month/date/diff',
        method: 'GET',
        data: params,
        callback: (res) => {
          if (res.res_code === '200') {
            this.months = res.data.months
            this.days = res.data.days
          } else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetPeriod()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnSubmit(){
      requestApi({
        url: '/receivings/register/license/' + this.receipt_no + '/submit',
        method: 'PUT',
        callback: (res) => {
          if (res.res_code === '200') {
            let snackBarOptions = {
              text: this.$t('common.message.add.success')
            }
            eventBus.$emit('SHOW_SNACKBAR', snackBarOptions)

            this.$router.push({path : '/myrequest/list'})
          }else{
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnSubmit()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },

    fnGoBefore(){
      this.$router.push({path:'/modification/registerlicense/step2/' + this.receipt_no})
    },

    fnGetReceipt(){
      requestApi({
        url: '/receivings/' + this.receipt_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            // draft 상태가 아니면 My Request 페이지로 이동
            if (res.data.service_type_code !== '6413'
              || res.data.receipt_status_type_code !== '4301'
              || res.data.receipt_step < 2) {
              this.$router.push('/myrequest/list')
            }
          }else {
            if (res.res_code === '401012') {
              utils.setTokenRefresh().then(() => {
                this.fnGetReceipt()
              })
            } else {
              eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
            }
          }
        }
      })
    },
  }
}
</script>